import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';

/*
 * The row's cells line up only if every column stacks parts of the same height: the collapsed line
 * (36px, two text lines), the "Additional sources" caption strip and one line per extra opt-in.
 * Table cells centre their content, so equal stacks keep the columns aligned. The opt-in line has a
 * fixed height rather than padding because its content differs per column — a tag is taller than a
 * text line — and padding would let the columns drift apart.
 */
export const AffiliateLeadCell = t0 => {
  const $ = _c(8);
  const {
    main,
    label,
    lines
  } = t0;
  let t1;
  if ($[0] !== main) {
    t1 = <div className="flex h-9 min-w-0 items-center">{main}</div>;
    $[0] = main;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== lines) {
    t2 = lines.length > 0 && <><div className="flex h-7.5 min-w-0 items-end">{label}</div>{lines.map(_temp)}</>;
    $[2] = label;
    $[3] = lines;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex min-w-0 flex-col">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const AffiliateOptinDate = t0 => {
  const $ = _c(8);
  const {
    time
  } = t0;
  const {
    user
  } = useUser();
  const t1 = user?.dateFormat;
  const t2 = user?.timeFormat;
  const t3 = user?.timezone;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== time) {
    t4 = dateTimeFormat(time, {
      dateFormat: t1,
      timeFormat: t2,
      timeZone: t3
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = time;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4 || $[6] !== time) {
    t5 = <time className="text-text-quaternary max-desktop:text-sm truncate" dateTime={time}>{t4}</time>;
    $[5] = t4;
    $[6] = time;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(line, index) {
  return <div key={index} className="flex h-10 min-w-0 items-center">{line}</div>;
}